<div class="row" *ngIf="!listo" style="height: 100%;">
    <div class="col-sm-12 text-center align-self-center">
        <i class="fa fa-spinner fa-3x fa-spin text-success"></i>
    </div>
</div>
<div *ngIf="listo && html" class="mt-5">
    <iframe [src]="html | safePipe" title="Iframe Example" [ngStyle]="iframeStyles">
    </iframe>
</div>